import { createFileRoute } from "@tanstack/react-router"
import InventoryAnalysis from "~/pages/sales-operations/inventory-overview/InventoryAnalysis"
import { usePageTracking } from "../../../../../hooks/usePageTracking"

export const Route = createFileRoute("/_auth/insights/inventory-overview/_layout/")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Inventory")
  return <InventoryAnalysis />
}
